module.exports = __webpack_public_path__ + "img/9788989646624.98569ac1.jpg";